module.exports = __webpack_public_path__ + "static/media/jessica.f6b2c01e.jpg";